import { Box } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

import Footer from '@/components/Footer/Footer';
import { Logo } from '@/components/Logo';
import LandingHeader from '@/components/Nav/LandingHeader';
import Loader from '@/components/Loader/Loader';
import { blue } from '@/theme/gradient';
import { isNonEmptyString } from '@/lib/predicates';
import { PATHNAMES } from '@/lib/routes';

import type { Props as PageContentProps } from '@/components/Page/PageContent';

const DynamicPageContent = dynamic<PageContentProps>(
  () => import(/* webpackChunkName: "page_content" */'@/components/Page/PageContent').then((mod) => mod.PageContent),
  {
    ssr: false,
    loading: () => <Loader />,
  }
);

const LandingPage = () => {
  const router = useRouter()
  const { slug } = router.query;
  const isReady = isNonEmptyString(slug);

  if (!isReady) {
    return null;
  }

  return (
    <Box minH="100vh" bg="#0a0a0b">
        <LandingHeader
          zIndex="100"
          boxShadow={'1px 1px 1px #0000001f'}
          transition="box-shadow 0.3s ease-in-out"
          style={{ background: blue }}
        >
          <Link href={PATHNAMES.home} passHref>
            <Logo
              title="Homepage"
              alt="Homepage"
              ml={6}
              w={{ base: '116px', md: '116px' }}
              color={['white', 'white', 'primary.500', 'primary.500']}
            />
          </Link>
        </LandingHeader>
        <Box minH="60vh" pt={20} bg="#f7f7f7">
          <DynamicPageContent slug={slug as string} />
        </Box>
      <Footer />
    </Box>
  );
};

export default LandingPage;
